import { PageHelmet } from 'components/common/PageHelmet';
import { useCommonTranslation } from '../../hooks/i18n/useCommonTranslation';
import {
  Card,
  CardFooter,
  PatientInner,
  PatientLayoutWrapper,
  UnAuthGraphics,
} from '../../components/common';
import { useClientRect } from '../../hooks/getBoundingClientRect';
import { FormDesc, FormTitle } from './AddHospital/AddHospitalForm.styled';
import { CommonButton, CommonLink } from '../../components/common/Forms/Button';
import { useSite } from '../../context/SiteContext';
import { useAuth } from '../../context/AuthContext';
import { PATIENT_ADD_HOSPITAL_URL } from '../../routes/AppRoutes';
import { FormActionsStyle } from '../../components/common/Forms/Forms.styled';
import { TopBannersLayout } from '../common/layout/TopBannersLayout';

export const ExpiredSitePatient = () => {
  const { t } = useCommonTranslation();
  const { activeSite } = useSite();
  const { logout } = useAuth();
  const { rect, ref } = useClientRect();

  return (
    <TopBannersLayout>
      <PatientLayoutWrapper>
        {ref.current && <UnAuthGraphics contentRect={rect} />}
        <PatientInner ref={ref}>
          <PageHelmet title={t('site-expired')} />
          <Card>
            <FormTitle>{t('site-expired')}</FormTitle>
            <FormDesc
              style={{
                fontSize: 'var(--h4)',
              }}
            >
              {t('patient-site-expired-description', {
                site: activeSite.name,
              })}
            </FormDesc>

            <FormActionsStyle align="center">
              <CommonLink
                variant="primary"
                to={PATIENT_ADD_HOSPITAL_URL}
                style={{ marginRight: 'var(--s3)' }}
              >
                {t('book-an-appointment')}
              </CommonLink>
            </FormActionsStyle>
            <CardFooter>
              <CommonButton variant="secondary" onClick={logout}>
                {t('logout')}
              </CommonButton>
            </CardFooter>
          </Card>
        </PatientInner>
      </PatientLayoutWrapper>
    </TopBannersLayout>
  );
};
